import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom';
import { formatDbDate } from '../../utils/dateFormater';
import DefaultAvatar from "../images/default_avatar.jpg"
import { formatWhatsAppNumber } from '../../utils/whatsappLinkFormater';

const SingleReservation = ({ order, user, productTypes }) => {




    const [copied, setCopied] = useState(false);




    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };









    const handleClassName = (orderStatus) => {


        if (orderStatus === "ORDERED") return "text-green-600 bg-green-100";
        if (orderStatus === "REVIEWED") return "text-pink-500 bg-pink-100";
        if (orderStatus === "DELIVERED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "SUSPENDED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "ON_HOLD") return "text-blue-500 bg-blue-100";
        if (orderStatus === "REFUNDED") return "text-green-600 bg-green-100";
        if (orderStatus === "COMMISSIONED") return "text-slate-500 bg-slate-100";
        if (orderStatus === "COMPLETED") return "text-purple-500 bg-purple-100";
        if (orderStatus === "CANCELLED") return "text-[#B04926] bg-[#b0482637]";
        if (orderStatus === "REVIEW_DELETED") return "text-red-500 bg-red-100";
        if (orderStatus === "SYSTEM_CANCELLED") return "text-red-500 bg-red-100";

    }











    return (
        <Fragment>
            <tr className="hover:bg-gray-50/50 transition-colors group">
                <td className="p-[1.2vmax_1.5vmax] text-center">
                    <span className="text-[0.9vmax] font-bold text-gray-400 group-hover:text-indigo-600 transition-colors">#{order?.id}</span>
                </td>
                <td className="p-[1.2vmax_1.5vmax]">
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-50 border border-gray-100 flex-shrink-0 shadow-sm group-hover:shadow-md transition-all">
                            <img src={order?.custom_image || DefaultAvatar} alt="" className="w-full h-full object-cover" />
                        </div>
                        <div className="flex flex-col gap-0.5">
                            <div className="flex items-center gap-2">
                                <span className="text-[0.75vmax] font-bold text-indigo-600 px-2 py-0.5 bg-indigo-50 rounded-md uppercase">{order?.country}</span>
                                <span className="text-[0.8vmax] font-bold text-gray-700">Product ID: {order?.product_id}</span>
                                <button
                                    onClick={() => handleCopy(order?.product_id)}
                                    className="text-gray-400 hover:text-indigo-600 transition-colors"
                                    title={copied ? "Copied" : "Copy"}
                                >
                                    <i className={`fa-regular ${copied ? "fa-circle-check text-green-500" : "fa-copy"} text-[0.8vmax]`}></i>
                                </button>
                            </div>
                            <span className="text-[0.75vmax] text-gray-400 font-medium truncate max-w-[200px]">{order?.product_name || 'Generic Product'}</span>
                        </div>
                    </div>
                </td>
                {user?.role !== "PM" && (
                    <td className="p-[1.2vmax_1.5vmax] text-center">
                        <div className="flex flex-col items-center gap-1">
                            <a 
                                href={formatWhatsAppNumber(order?.pm_country_code, order?.pm_phone_number)} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="w-8 h-8 rounded-full bg-green-50 text-green-600 flex items-center justify-center hover:bg-green-100 transition-all shadow-sm"
                            >
                                <i className="fa-brands fa-whatsapp text-lg"></i>
                            </a>
                            <span className="text-[0.85vmax] font-bold text-gray-700">{order?.pm_name}</span>
                        </div>
                    </td>
                )}
                <td className="p-[1.2vmax_1.5vmax] text-center">
                    <div className="flex flex-col items-center">
                        <span className="text-[0.85vmax] font-bold text-gray-700">{formatDbDate(order?.created_at).split(' ')[0]}</span>
                        <span className="text-[0.7vmax] text-gray-400 font-medium">{formatDbDate(order?.created_at).split(' ').slice(1).join(' ')}</span>
                    </div>
                </td>
                <td className="p-[1.2vmax_1.5vmax] text-center">
                    <div className={`inline-flex items-center gap-1 px-3 py-1 rounded-full font-bold text-[0.8vmax] ${order?.delay_days > 10 ? 'bg-red-50 text-red-600' : 'bg-amber-50 text-amber-600'}`}>
                        <i className="fa-solid fa-clock-rotate-left text-[0.7vmax]"></i>
                        {order?.delay_days} Days
                    </div>
                </td>
                <td className="p-[1.2vmax_1.5vmax] text-center">
                    <div className="flex flex-col items-center gap-2">
                        <span className={`px-3 py-1 rounded-full text-[0.75vmax] font-bold tracking-wide shadow-sm ${handleClassName(order?.status)}`}>
                            {order?.status === "ON_HOLD" ? "ON HOLD" : order?.status === "REVIEW_DELETED" ? "REVIEW DELETED" : order?.status === "SYSTEM_CANCELLED" ? "SYSTEM CANCEL" : order?.status}
                        </span>
                        
                        {/* Action Buttons Integrated Directly into Status Column for better flow */}
                        <div className="flex items-center gap-2 mt-1">
                            <Link
                                to={`/orders/order-details?order_id=${order?.id}`}
                                className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all shadow-sm active:scale-90"
                                title="View Details"
                            >
                                <i className="fa-solid fa-eye text-xs"></i>
                            </Link>
                            {user?.role === "PMM" && (
                                <Link
                                    to={`/orders/order-refunded?order_id=${order?.id}`}
                                    className="px-3 py-1.5 rounded-lg bg-green-600 text-white text-[0.75vmax] font-bold hover:bg-green-700 transition-all shadow-md shadow-green-100 active:scale-95 flex items-center gap-1.5"
                                >
                                    <i className="fa-solid fa-check-double"></i>
                                    {order?.status === "REVIEW_DELETED" ? "Add Refund" : "Refund"}
                                </Link>
                            )}
                        </div>
                    </div>
                </td>
            </tr>
        </Fragment>
    )
}

export default SingleReservation